export default {
    fields: {
        address: {
            label: 'Address',
            placeholder: 'Enter your address',
        },
        city: {
            label: 'City',
            placeholder: 'Select city',
        },
        country: {
            label: 'Country',
            placeholder: 'Country',
        },
        phone: {
            label: 'Phone',
            placeholder: '+3811231231',
        },
        email: {
            label: 'Email',
            placeholder: "company{'@'}myemail.com",
        },
        type: {
            label: 'Type',
            placeholder: 'Select type',
        },
    },
    business: 'Branch',
    parking: 'Parking',
}
